export const css = {
    root: '_3YlicBKD',
    heading: 'eNlkGsNl',
    article: 'FeNq1zRG',
    ' _key': 'afcpe-theme/afcpe/lcc-rcs/document'
};
export default css;
